import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IBaryPath } from '../../../../models/bary-paths.model';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-page-header',
  templateUrl: './bary-page-header.component.html',
  styleUrls: ['./bary-page-header.component.scss'],
})
export class BaryPageHeaderComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);

  @Input() fallback = '';
  @Input() button?: { label: string };

  @Output() buttonClickEvent = new EventEmitter();

  public title?: string;
  public backToList?: IBaryPath;
  public titleKey?: string;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public ngOnInit(): void {
    let currentRoute: ActivatedRouteSnapshot;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        currentRoute = this.router.routerState.snapshot.root;
        const title = this.getPageTitle(currentRoute);
        const params = this.getPageTitleParams(currentRoute);
        const dataObject = this.getPageDataObject(currentRoute, params);
        this.backToList = this.getBackToList(currentRoute);
        this.title = this.generateTitle(dataObject, title, params);
      }
    });
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
    let title: string = routeSnapshot.data['pageTitle'] || '';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }

    return title;
  }

  private getPageTitleParams(routeSnapshot: ActivatedRouteSnapshot): any {
    let dataParams: { data: string; params: any } = routeSnapshot.data['pageTitleParams'] ?? undefined;
    if (routeSnapshot.firstChild) {
      dataParams = this.getPageTitleParams(routeSnapshot.firstChild) || dataParams;
    }

    return dataParams;
  }

  private getPageDataObject(routeSnapshot: ActivatedRouteSnapshot, dataParams: { data: string; params: (...args: any[]) => any }): any {
    if (dataParams?.data) {
      let dataObject: { data: string; params: any } = routeSnapshot.data[dataParams.data] ?? undefined;
      if (routeSnapshot.firstChild) {
        dataObject = this.getPageDataObject(routeSnapshot.firstChild, dataParams) || dataObject;
      }

      return dataObject;
    }
  }

  private getBackToList(routeSnapshot: ActivatedRouteSnapshot): IBaryPath {
    let dataParams: IBaryPath = routeSnapshot.data['pageBackToList'] ?? undefined;
    if (routeSnapshot.firstChild) {
      dataParams = this.getBackToList(routeSnapshot.firstChild) || dataParams;
    }

    return dataParams;
  }

  private generateTitle(dataObject: any, title: string, dataParams: { data: string; params: (...args: any[]) => any }): string {
    if (dataObject && dataParams) {
      const evalParams = dataParams.params.call(undefined, dataObject) ?? undefined;
      if (title) {
        return this.translateService.instant(title, evalParams) as string;
      }
    } else {
      if (title) {
        return this.translateService.instant(title) as string;
      }
    }
    return '';
  }
}
